import React from 'react';

const Home = () => {
  return (
    <div style={{ padding: '10px' }}>
      
      {/* Welcome Message */}
      <div style={{ marginBottom: '40px', fontFamily: 'Myriad Pro, sans-serif' }}>
        <h1 style={{ fontSize: '36px', marginBottom: '10px', textAlign: 'center' }}>Welcome to Relief Roster</h1>
        <p style={{ fontSize: '18px', color: '#333' }}>
          This is your one-stop hub for managing substitute requests, signups, sub status tracking as well as staff absence requests and tracking. Let’s keep things running smoothly!
        </p>
      </div>

      {/* --- START OF FIRST BANNER --- */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '1200px',
        minHeight: '250px',
        backgroundColor: '#f5f5f5',
        borderRadius: '10px',
        overflow: 'hidden',
        margin: '0 auto',
        fontFamily: 'Myriad Pro, sans-serif'
      }}>
        {/* Text Section */}
        <div style={{ flex: 1, padding: '30px' }}>
          <h1 style={{ marginBottom: '20px', fontSize: '32px' }}>Substitute Management</h1>
          <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
            We help take the pain out of scheduling substitutes.
            Whether they are already in the building, from an external sub pool,
            <em> or both</em> – we have the flexibility to fit your needs.
          </p>
        </div>

        {/* Image Section */}
        <div style={{ flexShrink: 0, display: 'flex' }}>
          <img
            src="/wegotyou.png" // Make sure this image is in your /public folder
            alt="Two coworkers high-fiving"
            style={{ width: 'auto', height: '250px', objectFit: 'cover' }}
          />
        </div>
      </div>
      {/* --- END OF FIRST BANNER --- */}

      {/* Add some space between the banners */}
      <div style={{ height: '40px' }} /> 

      {/* --- START OF DUPLICATED BANNER --- */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        maxWidth: '1200px',
        minHeight: '250px',
        backgroundColor: '#f5f5f5',
        borderRadius: '10px',
        overflow: 'hidden',
        margin: '0 auto',
        fontFamily: 'Myriad Pro, sans-serif'
      }}>
        {/* You can change the text and image source here */}
        <div style={{ flex: 1, padding: '30px' }}>
          <h1 style={{ marginBottom: '20px', fontSize: '32px' }}>Absence & Leave Management</h1>
          <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
            Manage all staff absences, track leave balances, and ensure compliance. 
            Our system provides clear dashboards for administrators and a simple request 
            process for staff.
          </p>
        </div>

        {/* Image Section for the second banner */}
        <div style={{ flexShrink: 0, display: 'flex' }}>
          <img
            src="/Digital calendar.png" // Make sure this image is in your /public folder
            alt="Digital futuristic calendar"
            style={{ width: 'auto', height: '250px', objectFit: 'cover' }}
          />
        </div>
      </div>
      {/* --- END OF DUPLICATED BANNER --- */}

    </div>
  );
};

export default Home;